import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import {map, Observable} from "rxjs";
import {Injectable} from "@angular/core";
import {AssigmentModel, GenericAssigmentModel} from "../schemas/assigment.model";
import {environment} from 'src/environments/environment';
import {TeamModel} from "../schemas/team.model";
import {ResponsibleModel} from "../schemas/responsible.model";
import {CustomerModel} from "../schemas/customer.model";
import {GenericResponseModel} from "../schemas/genericResponse.model";

@Injectable({
    providedIn: 'root',
})
export class AssigmentService {
    constructor(private readonly http: HttpClient) {
    }

    getAssignmentsPaginator(pageSize: number,
                            pageIndex: number,
                            orderColumn?: string | null,
                            sort?: string | null,
                            customerId?: number,
                            teamId?: number,
                            respId?: string): Observable<GenericAssigmentModel> {
        let params = new HttpParams()
            .set('pageSize', pageSize.toString())
            .set('pageIndex', pageIndex.toString())
        if (orderColumn) {
            params = params.set('orderColumn', orderColumn);
        }
        if (sort) {
            params = params.set('sort', sort);
        }
        if (customerId) {
            params = params.set('customerId', customerId);
        }
        if (teamId) {
            params = params.set('teamId', teamId);
        }
        if (respId) {
            params = params.set('respId', respId);
        }

        return this.http.get<any>(`${environment.api_url_base_assignation_business}/assignation`, {params}).pipe(
            map(response => response as GenericAssigmentModel)
        );
    }

    saveAssignment(request: AssigmentModel, user = ''): Observable<GenericResponseModel> {
        const headers = new HttpHeaders({'Content-Type': 'application/json'});
        if (request.id) {
            return this.http.put<GenericResponseModel>(`${environment.api_url_base_assignation_business}/assignation?user=${user}`, request, {headers}).pipe(
                map(response => response as GenericResponseModel)
            );
        } else {
            return this.http.post<GenericResponseModel>(`${environment.api_url_base_assignation_business}/assignation?user=${user}`, request, {headers}).pipe(
                map(response => response as GenericResponseModel)
            );
        }
    }

    deleteAssignment(id: number, user: string): Observable<GenericResponseModel> {
        const headers = new HttpHeaders({'Content-Type': 'application/json'});
        return this.http.delete<GenericResponseModel>(`${environment.api_url_base_assignation_business}/assignation/${id}?user=${user}`, {headers}).pipe(
            map(response => response as GenericResponseModel)
        );
    }

    getTeams(name = ''): Observable<TeamModel[]> {
        return this.http.get<any>(`${environment.api_url_base_assignation_business}/area?name=${name}`).pipe(
            map(response => response.data as TeamModel[])
        );
    }
    getResponsible(name: string, area: string): Observable<ResponsibleModel[]> {
        return this.http.get<any>(`${environment.api_url_base_assignation_business}/area/responsible?area=${area}&name=${name}`).pipe(
            map(response => response.data as ResponsibleModel[])
        );
    }

    getCustomer(name = ''): Observable<CustomerModel[]> {
        return this.http.get<any>(`${environment.api_url_base_assignation_business}/area/customer?name=${name}`).pipe(
            map(response => response.data as CustomerModel[])
        );
    }


}